import { reset as userReset } from './user';

export function resetRepositories() {
  userReset();
}
